<style lang="scss" src="./_scss/instruction.scss"></style>
<template>
    <section class="mod_instruction">
        <h2 class="title">{{$lang[7]}}</h2>
        <ul class="list">
            <li class="item">{{$lang[8]}}</li>
            <li class="item">{{$lang[9]}}</li>
            <li class="item">{{$lang[28]}}</li>
            <li class="item">{{$lang[29]}} <a href="https://www.facebook.com/wetvthailand">{{$lang[32]}}</a></li>
        </ul>
    </section>
</template>

<script type="text/ecmascript">
export default {
  data() {
    return {

    };
  },
  async created() {

  },
  async mounted() {

  },
  computed: {

  },
  methods: {
  },
  components: {

  },
};
</script>
